export default __webpack_public_path__ + "static/media/1053.f19a0bb8.png";